module.exports = __webpack_public_path__ + "static/media/StrategicReportsAr.e6096f5c.pdf";